import styles from "./Badge.module.scss";

export type BadgeColor = "blue" | "grey" | "outline" | "white";

type BadgeProps = {
  name: string;
  color?: BadgeColor;
  className?: string;
};

export const Badge = ({
  name,
  color = "grey",
  className,
}: BadgeProps): JSX.Element => {
  return (
    <span className={`${styles.badge} ${styles[color]} ${className ?? ""}`}>
      {name}
    </span>
  );
};
